import { EventsBySportIdRequest } from "sb-resp-lib";
import { ComponentType } from "../../data";

export const ComponentTypeMapper = {
    [EventsBySportIdRequest.EventTypesEnum.Fixture]: (isMiniCard: boolean) => getFixtureType(isMiniCard),
    [EventsBySportIdRequest.EventTypesEnum.Outright]: (isMiniCard: boolean, isLive: boolean) => getOutrightType(isLive, isMiniCard),
    [EventsBySportIdRequest.EventTypesEnum.AggregateFixture]: (isMiniCard: boolean) => ComponentType.AggregateCard
}

const getFixtureType = (isMiniCard: boolean): ComponentType => {
    return isMiniCard
        ? ComponentType.MiniEventCard
        : ComponentType.EventCard
}

const getOutrightType = (eventIsLive: boolean, isMiniCard: boolean): ComponentType => {
    if (!eventIsLive) {
        return ComponentType.PreLiveOutright
    }

    return isMiniCard
            ? ComponentType.MiniOutright
            : ComponentType.LiveOutright
}
